import { makeStyles } from "@material-ui/core";

const useFormStyles = makeStyles({
  screenContainer: {
    display: "flex",
    padding: "20px 40px",
    gap: "50px",
    width: "100%",
    justifyContent: "space-evenly",
  },
  mainContent: {
    flex: 5,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    width: "75vw",
  },
  dashedWrapper: {
    padding: "32px",
    backgroundImage: `url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='22' ry='22' stroke='%23D4D4D4FF' stroke-width='4' stroke-dasharray='10' stroke-dashoffset='8' stroke-linecap='square'/%3e%3c/svg%3e")`,
    borderRadius: "22px",
  },
  formWrapper: {
    display: "flex",
    width: "100%",
    gap: "70px",
    paddingBottom: "20px",
  },
  separator: {
    border: "1px solid #E0E0E0",
    margin: "16px 0",
  },
  stepper: { flex: 1, marginTop: "-88px" },
  formTitle: {
    fontWeight: 500,
    width: "100%",
    fontSize: "24px",
    lineHeight: "30px",
    color: "rgb(14, 37, 106)",
  },
  formColumn: {
    width: "100%",
    justifyContent: "space-between",
    gap: "16px",
  },
  formRow: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "70px",
    "& > *": {
      width: "100%",
    },
  },
  flexRow: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    width: "100%",
    alignItems: "flex-end",
    gap: "6px",
  },
  subtitle: {
    fontFamily: "Dubai",
    fontWeight: 700,
    fontSize: "16px",
    linHeight: "27px",
    textTransform: "uppercase",
    color: "#115E67",
    marginBottom: "30px",
  },
  label: {
    fontFamily: "Dubai",
    fontWeight: 400,
    fontSize: "16px",
    lineHeight: "20px",
    color: "#374151",
  },
  disabledlabel: {
    fontFamily: "Dubai",
    fontWeight: 400,
    fontSize: "16px",
    lineHeight: "20px",
    color: "#A9A9A9",
  },
  optionsContainer: {
    display: "flex",
    justifyContent: "center",
    marginTop: "16px",
  },
  tabsOverride: {
    width: "100% !important",
    "& .MuiTabs-flexContainer": {
      justifyContent: "center",
      "& button": {
        maxWidth: "none",
      },
    },
  },
  inputField: {
    boxShadow: "0px 1px 2px rgba(0, 0, 0, 0.05)",
    borderRadius: "6px",
    height: "38px",
    marginTop: "0",
    marginLeft: "0",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "16px",
    lineHeight: "20px",
  },
  notchedOutline: { borderColor: "#D1D5DB" },
});

export const useButtonStyles = makeStyles({
  button: {
    color: "rgb(254, 254, 254)",
    textAlign: "center",
    borderRadius: "30px",
    borderWidth: "0px",
    fontSize: "16px",
    padding: "10px",
    width: "200px",
    cursor: "pointer",
    height: "45px",
    marginInlineEnd: "15px",
    textTransform: "none",
  },
  submitButton: {
    background: "rgb(14, 37, 106)",
    "&:hover": {
      backgroundColor: "rgb(14, 37, 106,.93)",
    },
    "&.MuiButton-root.Mui-disabled": {
      backgroundColor: "rgb(228, 228, 228)",
      color: "white",
    },
  },
  cancelButton: {
    color: "#797D81",
    background: "white",
    border: "1px solid #E6E6E6",
    "&:hover": {
      backgroundColor: "#E6E6E6",
    },
  },
  btncontainer: {
    position: "fixed",
    bottom: "15px",
  },
});
export default useFormStyles;
